import { userInitials } from '@/lib/utils'

export function CheckoutHeaderPreview({
  src,
  name,
  price,
}: {
  src: string | null
  name?: string
  price?: string
}) {
  const initials = userInitials(name?.trim() || '')

  return (
    <div className="flex w-[216px] items-center gap-3 px-1 py-2">
      {src ? (
        <img
          src={src}
          alt=""
          className="h-10 w-10 shrink-0 rounded-full object-cover bg-[#27272A]"
        />
      ) : (
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#27272A] text-xs font-semibold uppercase text-zinc-300"
          aria-hidden={!initials}
          title={name || undefined}
        >
          {initials || '—'}
        </div>
      )}
      <div className="min-w-0 text-left">
        <p className="truncate text-xs font-medium text-white">{name}</p>
        {price ? (
          <p className="truncate text-[10px] text-zinc-400">{price}</p>
        ) : null}
      </div>
    </div>
  )
}
